import { FunctionComponent } from "react";
import { useHistory } from "react-router-dom";
import FocusableButton from "../../components/shared/focusableButton/FocusableButton";
import { appVersion } from "../../modules/configs/appConfigs";
import * as styles from "./styles.module.scss";

const DeveloperTools: FunctionComponent = () => {
  const history = useHistory();

  const removeCache = () => {
    localStorage.clear();
    sessionStorage.clear();
    history.push("/");
    window.location.reload();
  };

  return (
    <div className={styles.developerContainer}>
      <div className={styles.dataContainer}>
        {window.navigator.userAgent}
        <br />
        width: {window.innerWidth} <br />
        height: {window.innerHeight} <br />
        <hr className={styles.divider} />
        Version: {appVersion}
      </div>
      <FocusableButton onClick={removeCache} label="حذف کش مرورگر و راه اندازی مجدد" focusKey="test" color="primary" />
    </div>
  );
};

export default DeveloperTools;
